import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_FAILED_SMS_RESPONSE_LOGS',
    icon: 'MessageCircleIcon',
    action: constants.action.permissionFailedSmsResponseLogsList,
    resource: constants.resource.smsresponselogs,
    children: [
      {
        title: 'DEBTIA_FAILED_SMS_RESPONSE_LOGS',
        route: 'smsresponselogs',
        action: constants.action.permissionFailedSmsResponseLogsList,
        resource: constants.resource.smsresponselogs,
      },
    ],
  },
]
